import { render, staticRenderFns } from "./DiscountRule.vue?vue&type=template&id=1fd6aa2a&scoped=true&"
import script from "./DiscountRule.vue?vue&type=script&lang=js&"
export * from "./DiscountRule.vue?vue&type=script&lang=js&"
import style0 from "./DiscountRule.vue?vue&type=style&index=0&id=1fd6aa2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd6aa2a",
  null
  
)

export default component.exports